import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";
import { vocabularize } from "src/Common/vocab";

const UnassignFormModal = ({ isOpen, woNumber, onClose, onUnassign }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed w-screen h-screen left-0 top-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
      <OutsideClickHandler onOutsideClick={onClose}>
        <div className="w-[436px] bg-white rounded-[6px] flex flex-col">
          <div className="border-b-[1px] border-borderColor py-3 px-4">
            <p className="text-[16px] font-OpenSansMedium font-[600] text-titleColor">
              UNASSIGN FORM
            </p>
          </div>

          <div className="p-[18px]">
            <p className="text-[12px] font-OpenSansMedium font-[500] text-titleColor text-center mb-4">
              {vocabularize("Are you sure you want to unassign the form from this Work Order?")}
            </p>

            <p className="text-[20px] font-OpenSansMedium font-[700] text-black text-center mb-6">
              {vocabularize("WO#")}: {woNumber || "-"}
            </p>

            <div className="w-full mt-3">
              <div className="flex items-center justify-between gap-4">
                <div
                  onClick={onClose}
                  className="w-[50%] h-[30px] text-[10px] rounded-[6px] border-[1px] border-subTitleColor flex items-center justify-center text-subTitleColor cursor-pointer"
                >
                  CANCEL
                </div>
                <div
                  onClick={onUnassign}
                  className="w-[50%] h-[30px] text-[10px] rounded-[6px] flex items-center justify-center bg-blueColor text-white cursor-pointer"
                >
                  UNASSIGN
                </div>
              </div>
            </div>
          </div>
        </div>
      </OutsideClickHandler>
    </div>
  );
};

export default UnassignFormModal;
